// Module
var code = `<div class="color-definitions">
    <div class="trackColor"></div>
    <div class="scrollColor"></div>
</div>
`;
// Exports
export default code;